export function formatEmployeeIdForKronos(eid) {
  let formattedEid = eid;
  if (formattedEid.slice(0, 1) === "e" || formattedEid.slice(0, 1) === "x") {
    formattedEid = formattedEid.slice(1);
  }
  return formattedEid.padStart(6, "0");
}

export function formatEmployeeIdFromKronos(eid) {
  let formattedEid = eid;
  while (formattedEid.slice(0, 1) === "0") {
    formattedEid = formattedEid.slice(1);
  }
  return "e" + formattedEid;
}
